import { useContext, useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { IconButtonSave } from '../../../../../component/IconSvg';
import { CHI_PHI_THUOC_FIELDS, CHI_PHI_THUOC_TYPE } from '../../../../constants/Thuoc';
import { PhanHeTiepDonContext } from '../../../../contexts/PhanHeTiepDonContext';
import { useKeVatTuContext } from '../../context';
import PaymentInfor from '../../../../../phan-he-vien-phi/components/PaymentInfor';
import useWorkflowOrgConfig from '../../../../../../hook/useWorkflowOrgConfig';
import { WORKFLOW_ORG_CONFIG_CODE } from '../../../../../utils/Constant';
import { calculateServicePrice } from '../../../../utils/Utils';

const ChiPhiVatTu = () => {
	const { benhNhanInfo } = useContext(PhanHeTiepDonContext);
	const { vatTuChecked } = useKeVatTuContext();

	const { config: paymentConfig } = useWorkflowOrgConfig({
		code: WORKFLOW_ORG_CONFIG_CODE.FORM_INFO_PAYMENT_ASSIGN
	});

	const [paymentItem, setPaymentItem] = useState<any>([]);

	const thongTinLanKham = benhNhanInfo.thongTinKhamBenh.visit;
	const thongTinChiPhi = {
		tongChiPhi: thongTinLanKham.ttTong,
		bhyt: thongTinLanKham.ttBhyt,
		benhNhan: thongTinLanKham.ttNguoiBenh,
		tamUng: thongTinLanKham.ttTamUng,
		daThu: thongTinLanKham.ttDaThu,
		mienGiam: thongTinLanKham.ttDiscountInv,
		conDu: thongTinLanKham.ttConNo,
	};

	const tongChiPhiVatTu = vatTuChecked.length
		? vatTuChecked.reduce(
				(acc, row) => acc + (row.deleted ? 0 : (row.donGia || 0) * (row.soLuong || 0)),
				0
		  )
		: 0;

	useEffect(() => {
		handleSetPaymentInfor(paymentConfig);
	}, [tongChiPhiVatTu, paymentConfig]);

	const handleSetPaymentInfor = async (config: any[]) => {
		const paymentByConfig = calculateServicePrice(
			thongTinChiPhi,
			vatTuChecked,
			'thanhTien',
			config
		);
		setPaymentItem(paymentByConfig);
	};

	return (
		<div className="d-flex justify-content-between align-items-center spaces p-10 mt-6 bg-white w-100">
			<PaymentInfor
				className="w-100 price-info"
				paymentData={paymentItem}
			/>
			<div className='spaces min-w-80'>
				<Button className="btn-fill" type="submit">
					<IconButtonSave /> Lưu lại
				</Button>
			</div>
		</div>
	);
};

export default ChiPhiVatTu;
